<template>
  <div class="pengumuman-container">
    <Forbidden
      v-if="getUserRole[getUserRole.length - 1].role_id != userRole.STUDENT"
      routerPath="incorrectRole"
    />
    <Forbidden v-else-if="!getReregistrationPeriodOpened" routerPath="notInPeriod" />
    <Forbidden
      v-else-if="getStudentTermStatus == termStatus.TERM_BREAK"
      routerPath="incorrectRole"
    />
    <Forbidden v-else-if="getHasFilledSurveyForm" routerPath="incorrectRole" />
    <div v-else>
      <section class="vector-background col center">
        <b-form id="survey-form">
          <h2 class="header-title">Survey Kepuasan</h2>
          <b-row align-v="start">
            <b-col sm="12">
              <b-form-group
                id="teacherPoints-group"
                class="mt-4"
                label="1. Seberapa baik pengajar dalam menyampaikan pengajaran dan membangun suasana belajar saat kelas maupun di grup Whatsapp?"
                label-for="teacherPoints"
              >
                <b-form-radio-group
                  id="teacherPoints"
                  v-model="form.teacherPoints"
                  name="teacherPoints"
                  button-variant="primary"
                  :options="form.answerOptions"
                  value-field="item"
                  text-field="name"
                  aria-describedby="teacherPoints-live-feedback"
                ></b-form-radio-group>
                <b-form-invalid-feedback
                  id="teacherPoints-live-feedback"
                  class="error_teacherPoints"
                >Mohon isi nilai pengajaran</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-v="start">
            <b-col sm="12">
              <b-form-group
                id="infaqPoints-group"
                class="mt-4"
                label="2. Seberapa sesuai nominal infaq program dengan manfaat yang kakak dapatkan?"
                label-for="infaqPoints"
              >
                <b-form-radio-group
                  id="infaqPoints"
                  v-model="form.infaqPoints"
                  name="infaqPoints"
                  button-variant="primary"
                  :options="form.answerOptions"
                  value-field="item"
                  text-field="name"
                  aria-describedby="infaqPoints-live-feedback"
                ></b-form-radio-group>
                <b-form-invalid-feedback
                  id="infaqPoints-live-feedback"
                  class="error_infaqPoints"
                >Mohon isi nilai kesesuaian infaq</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-v="start">
            <b-col sm="12">
              <b-form-group
                id="curriculumPoints-group"
                class="mt-4"
                label="3. Seberapa sesuai kurikulum pengajaran dengan harapan kakak?"
                label-for="curriculumPoints"
              >
                <b-form-radio-group
                  id="curriculumPoints"
                  v-model="form.curriculumPoints"
                  name="curriculumPoints"
                  button-variant="primary"
                  :options="form.answerOptions"
                  value-field="item"
                  text-field="name"
                  aria-describedby="curriculumPoints-live-feedback"
                ></b-form-radio-group>
                <b-form-invalid-feedback
                  id="curriculumPoints-live-feedback"
                  class="error_curriculumPoints"
                >Mohon isi nilai kesesuaian kurikulum</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-v="start">
            <b-col sm="12">
              <b-form-group
                id="mediaPoints-group"
                class="mt-4"
                label="4. Seberapa menyenangkan media ajar yang digunakan?"
                label-for="mediaPoints"
              >
                <b-form-radio-group
                  id="mediaPoints"
                  v-model="form.mediaPoints"
                  name="mediaPoints"
                  button-variant="primary"
                  :options="form.answerOptions"
                  value-field="item"
                  text-field="name"
                  aria-describedby="mediaPoints-live-feedback"
                ></b-form-radio-group>
                <b-form-invalid-feedback
                  id="mediaPoints-live-feedback"
                  class="error_mediaPoints"
                >Mohon isi nilai kesesuaian infaq</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <label
                for="obstacle"
              >5. Menurut kakak, apakah ada kendala yang dihadapi selama belajar di Qaaf? (terkait teknis, kurikulum, pengajar, dan lainnya.) (Bila tidak ada yang ingin disampaikan tulis "-")</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <b-form-textarea id="obstacle" v-model="form.obstacle"></b-form-textarea>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <label
                for="improvement"
              >6. Terakhir, apabila ada yang ingin kakak sampaikan untuk perbaikan program Qaaf, mohon diisi dibawah. Terimakasih atas waktunya. (Bila tidak ada yang ingin disampaikan tulis "-")</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <b-form-textarea id="improvement" v-model="form.improvement"></b-form-textarea>
            </b-col>
          </b-row>
        </b-form>
        <b-button
          id="submit"
          type="submit"
          size="sm"
          for="survey-form"
          ref="btn-submit"
          variant="none"
          class="primary mt-4"
          @click="$bvModal.show('confirm-modal')"
        >Lanjut</b-button>
      </section>

      <b-modal id="confirm-modal" hide-footer>
        <template v-slot:modal-title>Konfirmasi</template>
        <div class="d-block text-center">
          Pastikan semua pertanyaan sudah diisi dengan benar.
          <b
            class="rejected"
          >Tombol kirim baru akan muncul bila semua pertanyaan sudah diisi.</b>
        </div>
        <b-row class="ml-3 mt-3">
          <b-button
            class="col-5"
            variant="none"
            size="sm"
            @click="$bvModal.hide('confirm-modal')"
          >Oke</b-button>
          <b-button
            v-if="form.teacherPoints != 0 && form.infaqPoints!= 0 && form.curriculumPoints != 0 && form.mediaPoints != 0 && form.obstacle != '' && form.improvement != ''"
            class="col-5 ml-3 primary"
            size="sm"
            @click="onSubmit"
          >Kirim</b-button>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import Forbidden from "@/views/Forbidden";
import { mapGetters } from "vuex";
import User from "@/services/User";
import { UserRole, TermStatus } from "@/services/StatusCode";

export default {
  name: "SurveyForm",
  data() {
    return {
      form: {
        teacherPoints: 0,
        infaqPoints: 0,
        curriculumPoints: 0,
        mediaPoints: 0,
        obstacle: "",
        improvement: "",
        answerOptions: {
          1: 1,
          2: 2,
          3: 3,
          4: 4,
          5: 5
        }
      },
      userRole: UserRole,
      termStatus: TermStatus
    };
  },
  components: {
    Forbidden
  },
  methods: {
    onSubmit() {
      this.postForm();
    },
    postForm() {
      User.uploadSurveyForm(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName,
        this.form
      ).then(() => {
        location.href = location.origin + "/decision-form";
      });
    }
  },
  async created() {
    if (
      this.getTermName != "" &&
      (this.getStudentTermStatus == TermStatus.CONTINUE ||
        this.getStudentTermStatus == "")
    ) {
      await User.getHasFilledSurvey(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName
      );

      if (
        this.getHasFilledSurveyForm ||
        this.getStudentTermStatus == TermStatus.TERM_BREAK
      ) {
        router.push("/decision-form");
      }
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUserId: "getUserId",
      getUserRole: "getUserRole",
      getTermName: "getTermName",
      getRegistrationData: "getRegistrationData",
      getFullname: "getFullname",
      getReregistrationPeriodOpened: "getReregistrationPeriodOpened",
      getReregistrationPeriodData: "getReregistrationPeriodData",
      getHasFilledSurveyForm: "getHasFilledSurveyForm",
      getStudentTermStatus: "getStudentTermStatus"
    })
  }
};
</script>


<style lang="scss" scoped>
@import "@/styles/form.scss";

@media only screen and (min-width: 768px) {
  h1.header-title {
    font-size: $h1 !important;
  }

  h2.header-title {
    font-size: $h2 !important;
  }

  h3.header-title {
    font-size: $h3 !important;
  }

  .hero-message {
    margin-bottom: 5%;
    max-width: 50%;
  }
  .message {
    max-width: 100% !important;
    font-size: 16px !important;
  }
}

.pengumuman-container {
  min-height: inherit;
}

.rejected {
  color: red;
}

.hero-message {
  max-width: 75%;
  margin-bottom: $gap-m-2;
}

.message {
  margin-top: $gap-sm-1;
  text-align: center;
  max-width: 80%;
  font-size: 12px;
}

.message-container {
  min-width: 20%;
  max-height: 40%;
  margin-bottom: $gap-m-2;
}

.header-title {
  margin-bottom: $gap-m-1;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.nominal-container {
  text-align: center;
  .nominal {
    font-size: 24px;
  }
}
.pembayaran-container {
  .salin-jumlah {
    color: $primary;
  }
}

.success-payment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rekening-container {
  display: flex;
  align-items: center;
  margin: $gap-sm-2 0;

  .rekening {
    padding: $gap-sm-1 $gap-sm-2;
    background: $white;
    margin-right: $gap-sm-2;
  }
}

#submit {
  display: flex;
  align-items: center;

  .material-icons {
    color: white;
    margin-left: $gap-sm-1;
  }
}

.upload-container {
  margin-top: $gap-sm-2;
}

.red {
  color: #eb4d55;
}

.black {
  color: #000000;
}

.svg-4 {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-width: 40%;
  max-height: 20%;
}

.svg-5 {
  position: absolute;
  z-index: -2;
  bottom: 0;
  left: 0;
  max-width: 40%;
  max-height: 25%;
}

.svg-6 {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
  max-width: 40%;
  max-height: 50%;
}

.svg-7 {
  position: absolute;
  z-index: -2;
  bottom: 0;
  right: 0;
  max-width: 30%;
  max-height: 50%;
}
</style>

